import {AxiosError} from 'axios';
import {AnnouncementDetail} from 'web-library/models/Announcements';
import {PaginatedData} from 'web-library/models/List';
import {ApiPathParam} from 'web-library/models/SearchParamSchema';
import {GET_PAYMENT_MESSAGE_URL} from 'web-library/constants/apiUrls';
import {GET_PAYMENT_MESSAGE_QUERY_KEY} from 'web-library/constants/queryKeys';
import {useCustomQuery} from '../utils/useCustomQuery';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================
export interface PriorityAnnouncementRequest {
  apiPathParam: ApiPathParam;
}

// =============================================================================
// Query
// =============================================================================
interface Input {
  onSuccess?: (data: PaginatedData<AnnouncementDetail>) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
  requestData: PriorityAnnouncementRequest;
}

export const useGetPaymentMessages = ({
                                        onSuccess,
                                        onError,
                                        requestData,
                                      }: Input) => {
  const getPaymentMessages = async () => {
    const res = await axiosClient.get<PaginatedData<AnnouncementDetail>>(
        GET_PAYMENT_MESSAGE_URL(requestData.apiPathParam)
    );
    return res.data;
  };
  return useCustomQuery(GET_PAYMENT_MESSAGE_QUERY_KEY, getPaymentMessages, {
    onSuccess,
    onError,
  });
};
